import React from "react";
import { IonIcon, IonLabel, IonSpinner } from '@ionic/react';
import { micCircle, stopCircle, trashOutline } from 'ionicons/icons';

import AudioReactRecorder, { RecordState } from "audio-react-recorder";
import "audio-react-recorder/dist/index.css";
import "./AudioRecoder.css";

class AudioRecoder extends React.Component<any, any> {
  private timer: NodeJS.Timer | null = null;
  constructor(props: any) {
    super(props);

    this.state = {
      recordState: null,
      audioData: null,
      seconds: 0,
      minutes: 2,
      running: false,
      timer: null,
    };
  }

  start = () => {
    let timeoutId;
    this.setState({ running: true });
    this.timer = setInterval(() => {
      if (this.state.minutes === 0 && this.state.seconds === 0) {
        clearInterval(this.timer!);
        this.setState({ running: false });
      } else if (this.state.seconds === 0) {
        this.setState((prevState: { minutes: number; }) => ({
          minutes: prevState.minutes - 1,
          seconds: 59,
        }));
      } else {
        this.setState((prevState: { seconds: number; }) => ({
          seconds: prevState.seconds - 1,
        }));
      }
    }, 1000)
    this.setState({
      recordState: RecordState.START,
      timeoutId : setTimeout(() => {
        this.stop();
      }, 120000),
    });
  };

  stop = () => {
    this.setState({
      recordState: RecordState.STOP
    });
  };

  onStop = (data:any) => {
    this.setState({
      audioData: data
    });
    this.resetTimer();
    console.log("onStop: audio data", data);
    this.props.parentCallback(data);
  };

  resetTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.setState({
      minutes: 2,
      seconds: 0,
      running: true,
    });
  }

  render() {
    const { recordState } = this.state;

    return (
      <div>
        <AudioReactRecorder
          state={recordState}
          onStop={this.onStop}
          backgroundColor="rgb(255,255,255)"
        />
        {(!this.state.recordState || this.state.recordState === 'stop') ?

        <button id="record" className="start-button" onClick={this.start}>
          <IonIcon title="Record" className='mic' icon={micCircle} ></IonIcon>
        </button> :
        <button id="stop" className="save-button" onClick={this.stop}>
        <IonIcon title="Save" className='save' icon={stopCircle} ></IonIcon> 
        <div>
              {(() => {
                if (this.state.seconds > 0 && this.state.recordState == "start") {
                  return (
                    <div>
                      <h2 className='timer'>
                      <b>  {`${this.state.minutes < 10 ? '0' + this.state.minutes : this.state.minutes}:${this.state.seconds < 10 ? '0' + this.state.seconds : this.state.seconds
                          }`} </b>
                      </h2>
                    </div>
                  )
                }
              })()}
        </div>
        </button>
        }
        <audio
          id="audio"
          controls
          src={this.state.audioData ? this.state.audioData.url : null}
        >
        </audio>
      </div>
    );
  }
}

export default AudioRecoder;


